(function () {
  'use strict';
  if (window.BundleMonitorSelector) return;
  function BundleMonitorSelector(root, opts) {
    this.root = root;
    this.onChange = opts && opts.onChange || function () {};
    var self = this;
    root.addEventListener('change', function (event) {
      if (!event.target.matches('[data-monitor-option]')) return;
      self.paint();
      self.onChange();
    });
    // A monitor is always opt-in, including after browser form restoration.
    this.clear(false);
    this.enhance(opts || {});
  }
  // Use the same dropdown renderer, keyboard handling and price colours as NVR/HDD.
  BundleMonitorSelector.prototype.enhance = function (opts) {
    var self = this;
    var family = this.root.classList.contains('kitcust__row') ? 'kitcust' : 'pbundle';
    var source = this.root.querySelector('.smk-monitor__options');
    if (!source) return;
    var select = document.createElement('select');
    select.className = family + '__select';
    var inputs = Array.from(source.querySelectorAll('[data-monitor-option]'));
    select.id = inputs[0].name + '-select';
    select.setAttribute('aria-labelledby', inputs[0].name + '-label');
    inputs.forEach(function (input, index) {
      var option = document.createElement('option');
      var card = input.closest('.smk-monitor__option');
      var label = card.querySelector('.smk-monitor__label').textContent.trim();
      var detail = card.querySelector('small');
      option.value = input.value;
      option.dataset.label = input.value ? label.replace(/ monitor$/i, '') : 'No monitor';
      option.dataset.amount = input.value ? '+' + (input.dataset.priceLabel || '$' + (Number(input.dataset.price) / 100).toFixed(2)) : '';
      option.dataset.detail = detail ? detail.textContent.trim() : '';
      option.textContent = option.dataset.label + (option.dataset.amount ? ' — ' + option.dataset.amount : '');
      option.disabled = input.disabled;
      option.selected = input.checked;
      select.appendChild(option);
    });
    source.hidden = true;
    source.after(select);
    this.select = select;
    select.addEventListener('change', function () {
      var input = inputs.find(function (item) { return item.value === select.value; });
      if (!input || input.disabled) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (opts.createChoice) this.choice = opts.createChoice(select);
  };
  BundleMonitorSelector.prototype.getLines = function () {
    var input = this.root.querySelector('[data-monitor-option]:checked');
    if (!input || !input.value || input.disabled) return [];
    return [{ id: Number(input.value), quantity: 1, price: Number(input.dataset.price), label: input.dataset.label }];
  };
  BundleMonitorSelector.prototype.getTotal = function () {
    var line = this.getLines()[0];
    return line ? line.price : 0;
  };
  BundleMonitorSelector.prototype.getCartItems = function () {
    return this.getLines().map(function (line) { return { id: line.id, quantity: 1 }; });
  };
  BundleMonitorSelector.prototype.paint = function () {
    if (this.select) {
      var current = this.root.querySelector('[data-monitor-option]:checked');
      this.select.value = current ? current.value : '';
      if (this.choice) this.choice.sync();
    }
    this.root.querySelectorAll('[data-monitor-option]').forEach(function (input) {
      input.closest('.smk-monitor__option').classList.toggle('is-selected', input.checked);
    });
  };
  BundleMonitorSelector.prototype.clear = function (notify) {
    this.root.querySelectorAll('[data-monitor-option]').forEach(function (input) { input.checked = !input.value; });
    this.paint();
    if (notify !== false) this.onChange();
  };
  window.BundleMonitorSelector = BundleMonitorSelector;
})();
